import ExpandCaption from './ExpandCaption';
export default ExpandCaption;

